import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[whFlex]',
    standalone: false
})
export class FxFlexDirective implements AfterViewInit {
  // this directive is mainly created because whFlex lib is deprecated
  // DO NOT USE IN FURTHER DEVELOPMENT
  @Input('whFlex') set flexValue(value: string) {
    if (!value) {
      this.flex = '1 1 100%';
    } else if (value.includes(' ') && !value.includes('calc')) {
      const splitValues = value.split(' ');
      this.flex = splitValues[0] + ' ' + splitValues[1] + ' ' + splitValues[2];
    } else {
      if (
        !value.includes('px') &&
        !value.includes('%') &&
        !value.includes('calc')
      ) {
        value = value + '%';
      }
      this.flex = value;
    }
  }
  flex: string;
  constructor(private elRef: ElementRef) {}
  ngAfterViewInit(): void {
    // Written straight to the native element rather than through a
    // HostBinding: a HostBinding set from ngAfterViewInit is applied a CD
    // pass late (bindings are checked before AfterView hooks run), which
    // was invisible under zone.js's frequent global ticks but shows up as
    // a stale layout for a cycle wherever the host component uses OnPush.
    
    this.elRef.nativeElement.parentElement.style.display = 'flex';
    this.elRef.nativeElement.style.flex = this.flex;
  }
}
